export type ApprovalOddsEligibility = {
  productIncludeInApprovalOdds: boolean;
};

/** Case-insensitive: any product name containing "discover" is suppressed. */
export function hasDiscoverInProductName(name: string): boolean {
  return name.toLowerCase().includes('discover');
}

/**
 * Maps an offer to Marketplace-shaped eligibility flags.
 * MVP: invent product flag from Discover name match (covers Cap One–migrated cards).
 * Follow-up: read GraphQL flags from the offer instead; keep this return shape.
 */
export function toEligibility(offer: { product: { name: string } }): ApprovalOddsEligibility {
  return {
    productIncludeInApprovalOdds: !hasDiscoverInProductName(offer.product.name),
  };
}

export function isApprovalOddsDisplayEligible(eligibility: ApprovalOddsEligibility): boolean {
  return eligibility.productIncludeInApprovalOdds;
}
